export enum SectionSourceType {
  S3 = 'S3',
  Inline = 'INLINE',
  Database = 'DATABASE',
  Sharepoint = 'SHAREPOINT',
  User = 'USER',
  Workflow = 'WORKFLOW',
}
